<div
  class="user-activity-container"
  *appHasPermission="[
    { resource: Resources.Reports, scope: Scopes.Read },
    { resource: Resources.Logs, scope: Scopes.Read },
  ]"
>
  <div class="user-activity-header">
    <div class="title-section">
      <div class="title-container">
        <div class="inner-tab-title">User Activity</div>
        <app-button
          *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Export }"
          buttonVariant="accent"
          buttonType="button"
          [state]="exportButtonState"
          (buttonClick)="openExport()"
        >
          <img src="shared-assets/icons/download.png" alt="Export Icon" class="icon" />
          <span>Export</span>
        </app-button>
      </div>
    </div>
    <div class="filter-buttons">
      <app-button buttonVariant="filter" buttonType="button" [active]="filtersApplied" (buttonClick)="toggleFilters()">
        <img [src]="'shared-assets/icons/filter.png'" alt="Filter Icon" class="filter-icon" />
        <span>Filters</span>
        @if (filtersApplied) {
          <span class="clear-icon" (click)="onFilterReset(); $event.stopPropagation()" title="Clear filters">
            <img src="shared-assets/icons/close.png" alt="Filter Icon" class="clear-icon" />
          </span>
        }
      </app-button>

      <app-date-picker
        [selectedPeriod]="selectedPeriod"
        (rangeChange)="onDateRangeSelected($event)"
        (presetSelected)="onPresetPeriod($event)"
        [isDisabled]="isDisabled"
      ></app-date-picker>

      <app-pill-search
        [searchText]="searchText"
        placeholder="Search"
        (searchChange)="updateSearch($event)"
        [isDisabled]="isDisabled"
      ></app-pill-search>
    </div>
  </div>
  <div class="table-container">
    @if (initialLoading) {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading user activities..."></app-loading-spinner>
      </div>
    }

    @if (error && !initialLoading) {
      <div class="error-container">
        <p class="error-message">{{ error }}</p>
        <app-button buttonVariant="retry" buttonType="button" (buttonClick)="loadUserActivities()">Retry</app-button>
      </div>
    }

    @if (!initialLoading && !error) {
      <table class="user-activity-table">
        <thead>
          <tr>
            <th>Activity</th>
            <th>Name/Wallet Label</th>
            <th>User</th>
            <th>Date</th>
          </tr>
        </thead>
        @if (userActivities.length) {
          <tbody>
            @for (userActivity of userActivities; track $index) {
              <tr
                class="activity-row"
                [class.activity-row--clickable]="!!userActivity.failedLoginInfo"
                (click)="onRowActivate($event, userActivity)"
                [attr.tabindex]="userActivity.failedLoginInfo ? 0 : null"
                [attr.role]="userActivity.failedLoginInfo ? 'button' : null"
                [attr.aria-label]="userActivity.failedLoginInfo ? 'View failed login details' : null"
                (keydown.enter)="onRowActivate($event, userActivity)"
                (keydown.space)="onRowActivate($event, userActivity)"
              >
                <td>{{ userActivity.activity }}</td>
                <td>{{ userActivity.label }}</td>
                <td>{{ userActivity.user }}</td>
                <td>
                  <span class="date-cell">
                    <span>{{ formatDateStandard(userActivity.date) }}</span>
                    @if (userActivity.failedLoginInfo) {
                      <button
                        type="button"
                        class="details-button"
                        [class.details-button--active]="isSelectedActivity(userActivity)"
                        (click)="$event.stopPropagation(); onActivityClick(userActivity)"
                      >
                        View details
                      </button>
                    }
                  </span>
                </td>
              </tr>
            }
          </tbody>
        } @else {
          <tr>
            <td colspan="4">
              <app-empty-state [filtersApplied]="filtersApplied" [searchText]="searchText"></app-empty-state>
            </td>
          </tr>
        }
      </table>
    }

    <app-show-more
      [isShowMore]="hasUserActivities && hasMoreUserActivities && !initialLoading"
      [isLoading]="isLoading"
      (loadMore)="loadMoreActivities()"
    >
    </app-show-more>
  </div>
  @if (sidebarOpen && selectedActivity) {
    <div class="transaction-details-aside" animate.enter="slide-in-right" animate.leave="slide-out-right">
      <app-failed-login-drawer
        [failedLoginInfo]="selectedActivity.failedLoginInfo!"
        [activityType]="selectedActivity.activity"
        [userName]="selectedActivity.user"
        [entityNameValue]="selectedActivity.label"
        [activityDate]="formatDateStandard(selectedActivity.date)"
        (closed)="closeActivityDetails()"
      ></app-failed-login-drawer>
    </div>
  }
</div>
